import * as React from 'react';
import FullWidthContainer from 'components/FullWidthContainer';
import Container from '@mui/material/Container';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid2';
import zparse from 'components/zparse';
import theme from 'utils/theme';

const TwoColumn = ({ orientation, flipOrientation, flush, background, backgroundImage, backgroundProps, padding, contentBlocks }) => {
	const media = {
		xs: useMediaQuery(theme.breakpoints.down('xs')),
		sm: useMediaQuery(theme.breakpoints.between('xs', 'sm')),
		md: useMediaQuery(theme.breakpoints.between('sm', 'md')),
		lg: useMediaQuery(theme.breakpoints.up('lg')),
	};

	const inlineStyle = {
		...(backgroundImage ? {
			backgroundImage: `url(${process.env.CDN_DOMAIN||''}${backgroundImage})`,
			...(backgroundProps ? {
				...(backgroundProps.indexOf('cover') !== -1 ? {
					backgroundSize: 'cover',
				} : null),
				...(backgroundProps.indexOf('fixed') !== -1 ? {
					backgroundAttachment: 'fixed',
				} : null),
				...(backgroundProps.indexOf('repeat') !== -1 ? {
					backgroundRepeat: 'repeat',
				} : {backgroundRepeat: 'no-repeat'}),
			} : null),
		} : null),
	}

	return (
		<FullWidthContainer sx={(Object.keys(inlineStyle).length > 0 ? inlineStyle : null)} className={`SmartTag-root TwoColumn-root ${background||''} ${padding ? 'padding-normal' : ''} ${flush ? 'margin-flush' : ''}`}>
			<Container>
				<Grid container direction={orientation} justifyContent="center" className="TwoColumn-container">
					{contentBlocks.map((block, index) => {
						let breakpoints = block.breakpoints.filter(item => !!item !== false);
						if (breakpoints.length > 0) {
							breakpoints = breakpoints.filter(key => media[key]);
							if (breakpoints.length === 0)return null;
						}
						return (
							<Grid key={index} size={{xs: 12, sm: 6}} className="TwoColumn-column">
								{zparse(block.body)}
							</Grid>
						)
					})}
				</Grid>
			</Container>
		</FullWidthContainer>
	)
}

export default TwoColumn;